var _defs, _path, _g, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _g7, _path6, _g8, _g9, _path7, _g0, _path8, _path9, _g1, _path0, _path1, _path10, _path11, _path12, _g10, _path13, _path14, _path15, _path16, _g11, _path17, _path18, _path19, _path20, _g12, _g13, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 164,
    height: 166,
    viewBox: "0 0 164 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6232",
    "data-name": "Rectangle 6232",
    width: 164,
    height: 166,
    transform: "translate(0 -0.176)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6226",
    "data-name": "Rectangle 6226",
    width: 164,
    height: 166,
    transform: "translate(0 -0.176)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6214",
    "data-name": "Rectangle 6214",
    width: 33.081,
    height: 32.98,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6215",
    "data-name": "Rectangle 6215",
    width: 52.374,
    height: 36.118,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6216",
    "data-name": "Rectangle 6216",
    width: 37.723,
    height: 33.772,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6217",
    "data-name": "Rectangle 6217",
    width: 39.457,
    height: 39.026,
    fill: "rgba(0,0,0,0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6218",
    "data-name": "Rectangle 6218",
    width: 27.574,
    height: 35.168,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6219",
    "data-name": "Rectangle 6219",
    width: 91.964,
    height: 116.227,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6220",
    "data-name": "Rectangle 6220",
    width: 114.944,
    height: 101.833,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6221",
    "data-name": "Rectangle 6221",
    width: 19.087,
    height: 30.634,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6222",
    "data-name": "Rectangle 6222",
    width: 22.966,
    height: 18.567,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6223",
    "data-name": "Rectangle 6223",
    width: 35.836,
    height: 18.613,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6224",
    "data-name": "Rectangle 6224",
    width: 21.455,
    height: 20.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6225",
    "data-name": "Rectangle 6225",
    width: 8.856,
    height: 8.634,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24096",
    "data-name": "Path 24096",
    d: "M1525.479,1545.172c-7.12,3.3-15.24,11.272-18.736,18.161a12.074,12.074,0,0,0-1.169,7.24c2.56,17.228,15.8,28.246,32.691,28.508,8.195.81,17.531,1.806,27.7,7.934a1.513,1.513,0,0,0,2.11-2.038c-5.923-10.234-6.69-19.508-7.3-27.647.166-16.758-10.636-30.169-27.985-33.123a12.553,12.553,0,0,0-2.106-.178,12.394,12.394,0,0,0-5.21,1.144",
    transform: "translate(-1505.442 -1544.028)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.955,
    y1: 0.86,
    x2: -0.954,
    y2: 0.86,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb201a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#ef7d30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef7d30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6228",
    "data-name": "Rectangle 6228",
    width: 41.638,
    height: 40.856,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6229",
    "data-name": "Rectangle 6229",
    width: 41.638,
    height: 36.382,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6230",
    "data-name": "Rectangle 6230",
    width: 0.02,
    height: 0.029,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rocket",
    transform: "translate(0 0.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7691",
    "data-name": "Group 7691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7677",
    "data-name": "Group 7677",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7676",
    "data-name": "Group 7676",
    clipPath: "url(#clip-path-2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24066",
    "data-name": "Path 24066",
    d: "M1505.664,601.678l3.958,6.729,18.369,31.231s7.58.149,14.712.15c5.765,0,11.239-.092,12.182-.437,2.91-1.065,8.324-8.8-8.963-21.475s-40.257-16.2-40.257-16.2",
    transform: "translate(-1405.529 -562.024)",
    fill: "#eb201a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7642",
    "data-name": "Group 7642",
    transform: "translate(104.092 44.784)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7641",
    "data-name": "Group 7641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7640",
    "data-name": "Group 7640",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24067",
    "data-name": "Path 24067",
    d: "M1566.331,679.513l-1.16,1.6,18.369,31.231s7.58.149,14.712.15c-10.073-1.878-11.879-9.963-11.879-9.963-11.725-17.761-20.042-23.017-20.042-23.017",
    transform: "translate(-1565.171 -679.513)",
    fill: "#000072"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7645",
    "data-name": "Group 7645",
    transform: "translate(100.134 39.654)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7644",
    "data-name": "Group 7644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7643",
    "data-name": "Group 7643",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24068",
    "data-name": "Path 24068",
    d: "M1505.664,601.678l2.016,3.427c6.882,1.448,23.7,5.774,37.1,15.6,10.358,7.593,12.566,13.414,12.045,17.09,2.241-3,2.725-9.928-10.906-19.921-17.287-12.674-40.257-16.2-40.257-16.2",
    transform: "translate(-1505.664 -601.678)",
    fill: "#fefefe"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24069",
    "data-name": "Path 24069",
    d: "M585.315,1554.089c12.344,17.448,20.287,12.281,21.435,9.427.457-1.136.706-9.043.837-15.949.109-5.681.138-10.686.138-10.686L570,1513.8s.414,3.188,1.578,8.093c1.949,8.223,6,21.27,13.735,32.2",
    transform: "translate(-532.094 -1414.027)",
    fill: "#eb201a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7648",
    "data-name": "Group 7648",
    transform: "translate(38.001 99.601)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7647",
    "data-name": "Group 7647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7646",
    "data-name": "Group 7646",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24070",
    "data-name": "Path 24070",
    d: "M572.972,1519.35c3.329,1.843,19.126,10.989,26.94,22.754a11.8,11.8,0,0,1,9.067,2.924c.109-5.681.138-10.686.138-10.686l-37.723-23.086s.414,3.188,1.578,8.093",
    transform: "translate(-571.394 -1511.257)",
    fill: "#000072"
  }))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24071",
    "data-name": "Path 24071",
    d: "M92.409,137.572a24.06,24.06,0,0,0,4.168.363c.365,0,.745,0,1.137-.021a21.469,21.469,0,0,0,2.253-.206c.559-.082,1.125-.19,1.69-.327l35.224-34.03c.117-.422.217-.845.3-1.265a22.2,22.2,0,0,0,.4-4.394c0-.077,0-.153,0-.229h0a22.424,22.424,0,0,0-.263-3.265c-4.55-29.7-47-70.75-86.537-77.681C41.5,14.89,32.387,15.14,23.961,17.855l-.017.006a8.981,8.981,0,0,0-2.954,1.619,8.557,8.557,0,0,0-.8.751,8.814,8.814,0,0,0-1.663,2.5c-.086.193-.164.391-.236.591C15.335,31.6,14.847,40.627,16.252,49.86c5.984,39.346,46.316,82.446,76.157,87.712",
    transform: "translate(-14.466 -14.481)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7651",
    "data-name": "Group 7651",
    transform: "translate(17.734 22.87)",
    opacity: 0.25,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7650",
    "data-name": "Group 7650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7649",
    "data-name": "Group 7649",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24072",
    "data-name": "Path 24072",
    d: "M272.288,381.64c6.547,6.656,18.5,5.636,26.689-2.278a24.088,24.088,0,0,0,5.567-8.106c2.7-6.558,1.954-13.658-2.588-18.276a14.31,14.31,0,0,0-5.337-3.41h0l-.01,0q-.438-.159-.886-.291l-3.971-1.31c-5.765-2.239-13.314-.512-18.878,4.863s-7.5,12.809-5.386,18.578l1.22,3.965q.122.45.273.889l0,.01h0a14.143,14.143,0,0,0,3.3,5.374",
    transform: "translate(-266.653 -347.009)",
    fill: "none"
  }))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24073",
    "data-name": "Path 24073",
    d: "M1148.893,1220.277a8.936,8.936,0,0,0,3.192,2.065,21.122,21.122,0,0,0,5.08-.555l35.224-34.03a21.262,21.262,0,0,0,.692-5.888h0a8.7,8.7,0,0,0-1.75-2.589c-6.079-6.179-20.507-2.011-32.225,9.31s-16.291,25.507-10.213,31.688",
    transform: "translate(-1069.975 -1098.888)",
    fill: "#eb201a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7654",
    "data-name": "Group 7654",
    transform: "translate(60.652 68.029)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7653",
    "data-name": "Group 7653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7652",
    "data-name": "Group 7652",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24074",
    "data-name": "Path 24074",
    d: "M911.985,1032.207a75.447,75.447,0,0,0,24.183,35.168l3.391-3.589",
    transform: "translate(-911.985 -1032.207)",
    fill: "#371a45"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24075",
    "data-name": "Path 24075",
    d: "M16.252,49.857h0a39.49,39.49,0,0,1,11.9-22.116,40.1,40.1,0,0,1,22.615-11.23c-9.279-1.627-18.4-1.375-26.829,1.345a8.9,8.9,0,0,0-5.65,5.459c-2.958,8.283-3.446,17.308-2.042,26.541",
    transform: "translate(-14.466 -14.478)",
    fill: "#eb201a"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7657",
    "data-name": "Group 7657",
    transform: "translate(2.71 3.373)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7656",
    "data-name": "Group 7656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7655",
    "data-name": "Group 7655",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24076",
    "data-name": "Path 24076",
    d: "M118.057,167.1a24.967,24.967,0,0,0,4.236.321,22.041,22.041,0,0,0,5.171-.6l5.256-4.957a29.868,29.868,0,0,1-3.548-3.757c-.453.026-.893.037-1.312.039a24.913,24.913,0,0,1-4.235-.321c-30.3-4.947-70.908-47.33-76.623-86.307A55.646,55.646,0,0,1,47.54,51.19l-.017.006a8.979,8.979,0,0,0-2.954,1.619,8.945,8.945,0,0,0-.807,1.624c-3.087,8.244-3.668,17.2-2.327,26.348,5.714,38.977,46.325,81.362,76.622,86.309",
    transform: "translate(-40.756 -51.19)",
    fill: "#371a45"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7660",
    "data-name": "Group 7660",
    transform: "translate(4.063 3.368)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7659",
    "data-name": "Group 7659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7658",
    "data-name": "Group 7658",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24077",
    "data-name": "Path 24077",
    d: "M61.09,55.992a57.12,57.12,0,0,1,22.7-.207c39.318,7,81.6,48.112,86.181,77.8a22.542,22.542,0,0,1,.267,3.264h0a21.33,21.33,0,0,1-.676,5.883l-9.034,8.773q.293.71.556,1.442l14.265-13.852a21.3,21.3,0,0,0,.677-5.883h0a22.553,22.553,0,0,0-.267-3.263c-4.583-29.686-46.864-70.795-86.182-77.8-9.227-1.644-18.291-1.41-26.667,1.291l-.16.054a8.815,8.815,0,0,0-1.663,2.5",
    transform: "translate(-61.09 -51.113)",
    fill: "#fefefe"
  }))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24078",
    "data-name": "Path 24078",
    d: "M1260.969,1328.588l-7.959-15.271a12.156,12.156,0,0,1-.266-10.745,40.656,40.656,0,0,1,21.7-20.977,12.445,12.445,0,0,1,10.786.557l15.225,8.286a7.283,7.283,0,0,1,3.83,6.966c-1.053,12.618-23.636,34.434-36.391,35.156a7.376,7.376,0,0,1-6.93-3.972",
    transform: "translate(-1168.381 -1196.224)",
    fill: "#181c28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7663",
    "data-name": "Group 7663",
    transform: "translate(83.62 99.608)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7662",
    "data-name": "Group 7662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7661",
    "data-name": "Group 7661",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24079",
    "data-name": "Path 24079",
    d: "M1261.952,1511.37l10.325,15.72s4.623,3.56,4.118,3.957-3.95,6.789-3.95,6.789l1.177,4.167-7.4-1.835.265-3.177-9.139-14.9",
    transform: "translate(-1257.346 -1511.37)",
    fill: "#371a45"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7666",
    "data-name": "Group 7666",
    transform: "translate(104.324 84.628)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7665",
    "data-name": "Group 7665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7664",
    "data-name": "Group 7664",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24080",
    "data-name": "Path 24080",
    d: "M1572.84,1284.072l16.393,9.37,1.1.542s1.565,5.919,1.254,5.552-7.092,2.812-7.092,2.812l-1.136.29-1.409-5.332-13.288-11.266",
    transform: "translate(-1568.66 -1284.072)",
    fill: "#fefefe"
  }))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24081",
    "data-name": "Path 24081",
    d: "M271.475,305.091c6.547,6.656,18.5,5.636,26.689-2.278a24.088,24.088,0,0,0,5.567-8.106c2.7-6.558,1.954-13.658-2.588-18.276a14.308,14.308,0,0,0-5.337-3.41h0l-.01,0q-.438-.158-.886-.291l-3.971-1.31c-5.765-2.239-13.314-.511-18.878,4.863s-7.5,12.809-5.386,18.577l1.22,3.965q.122.45.273.889l0,.01h0a14.144,14.144,0,0,0,3.3,5.374",
    transform: "translate(-248.161 -252.635)",
    fill: "#d50511"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7669",
    "data-name": "Group 7669",
    transform: "translate(19.734 38.238)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7668",
    "data-name": "Group 7668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7667",
    "data-name": "Group 7667",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24082",
    "data-name": "Path 24082",
    d: "M300.305,594.408c6.547,6.656,18.5,5.636,26.689-2.278a24.086,24.086,0,0,0,5.567-8.106h0l-6.418-3.835c-14.851,21.911-29.416,7.947-29.416,7.947q.122.45.273.889l0,.01h0a14.143,14.143,0,0,0,3.3,5.374",
    transform: "translate(-296.725 -580.189)",
    fill: "#000072"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24083",
    "data-name": "Path 24083",
    d: "M269.456,299.274c5.709,5.8,16.129,4.915,23.272-1.986s8.306-17.2,2.6-23-16.129-4.915-23.272,1.986-8.306,17.2-2.6,23",
    transform: "translate(-248.152 -252.627)",
    fill: "#d50511"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24084",
    "data-name": "Path 24084",
    d: "M367.742,391.241c4.323,2.8,10.89,1.747,15.579-2.783s5.918-11.009,3.2-15.363c-4.323-2.8-10.89-1.748-15.58,2.782s-5.918,11.009-3.2,15.363",
    transform: "translate(-341.958 -347.063)",
    fill: "#d50511"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7672",
    "data-name": "Group 7672",
    transform: "translate(24.534 25.703)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7671",
    "data-name": "Group 7671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7670",
    "data-name": "Group 7670",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24085",
    "data-name": "Path 24085",
    d: "M370.151,408.471c4.323,2.8,10.89,1.747,15.579-2.783s5.918-11.009,3.2-15.363c-.18-.116-.364-.227-.552-.33.721,3.943-.838,8.594-4.454,12.088-4.495,4.342-10.714,5.489-15.028,3.111a9.327,9.327,0,0,0,1.25,3.276",
    transform: "translate(-368.901 -389.996)",
    fill: "#371a45"
  }))))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24086",
    "data-name": "Path 24086",
    d: "M314.9,338.808c-4.511-4.586-3.6-12.741,2.026-18.178a15.946,15.946,0,0,1,9.517-4.533,10.78,10.78,0,0,1,8.872,2.989,10.563,10.563,0,0,1,2.79,8.865,16.367,16.367,0,0,1-15.533,13.89,10.576,10.576,0,0,1-7.671-3.034m11.713-20.884a14.087,14.087,0,0,0-8.395,4.019c-4.9,4.731-5.791,11.722-1.992,15.584S327.1,340.682,332,335.951a13.867,13.867,0,0,0,4.269-8.214,8.38,8.38,0,0,0-8.615-9.861q-.511,0-1.038.048",
    transform: "translate(-291.278 -295.212)",
    fill: "#000072"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24087",
    "data-name": "Path 24087",
    d: "M328.4,351.176a8.8,8.8,0,0,0,1.5,1.223c-2.715-4.354-1.486-10.833,3.2-15.363s11.256-5.583,15.58-2.782a8.74,8.74,0,0,0-1.2-1.518c-4.162-4.231-11.808-3.533-17.08,1.56s-6.171,12.65-2.009,16.881",
    transform: "translate(-304.117 -308.221)",
    fill: "#ffcf02"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24088",
    "data-name": "Path 24088",
    d: "M328.4,351.176a8.8,8.8,0,0,0,1.5,1.223c-2.715-4.354-1.486-10.833,3.2-15.363s11.256-5.583,15.58-2.782a8.74,8.74,0,0,0-1.2-1.518c-4.162-4.231-11.808-3.533-17.08,1.56s-6.171,12.65-2.009,16.881",
    transform: "translate(-304.117 -308.221)",
    fill: "#d50511"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24089",
    "data-name": "Path 24089",
    d: "M316.382,340.32a9.74,9.74,0,0,1-1.659-1.351,10.563,10.563,0,0,1-2.79-8.865,15.7,15.7,0,0,1,4.815-9.313c5.628-5.437,13.877-6.13,18.389-1.543a9.692,9.692,0,0,1,1.321,1.677.911.911,0,0,1-.143,1.139.933.933,0,0,1-1.152.11c-4.045-2.621-10.112-1.5-14.427,2.671s-5.6,10.15-3.062,14.225a.911.911,0,0,1-.141,1.138.932.932,0,0,1-1.152.112m15.432-21.269c-3.957-2.066-9.64-.939-13.773,3.053a13.866,13.866,0,0,0-4.269,8.214,9.4,9.4,0,0,0,.838,5.356,15,15,0,0,1,4.834-12.144,15.73,15.73,0,0,1,10.719-4.59,12.252,12.252,0,0,1,1.65.11",
    transform: "translate(-291.103 -295.374)",
    fill: "#371a45"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24090",
    "data-name": "Path 24090",
    d: "M354.205,378.972a.921.921,0,0,1-.281-.286c-2.992-4.8-1.586-11.739,3.345-16.5s11.968-5.98,16.732-2.893a.922.922,0,0,1,.281.286c2.992,4.8,1.585,11.739-3.346,16.5a15.731,15.731,0,0,1-10.719,4.59,10.975,10.975,0,0,1-6.012-1.7m4.356-15.474c-4.253,4.109-5.565,9.98-3.168,14.049,4.043,2.477,10,1.327,14.252-2.782s5.565-9.98,3.17-14.048c-4.044-2.478-10-1.327-14.253,2.781M354.708,378.2h0Z",
    transform: "translate(-328.927 -334.027)",
    fill: "#371a45"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7675",
    "data-name": "Group 7675",
    transform: "translate(27.897 27.887)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7674",
    "data-name": "Group 7674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7673",
    "data-name": "Group 7673",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24091",
    "data-name": "Path 24091",
    d: "M419.921,431.369c1.085,1.1,3.258-.251,5.475-2.393s3.638-4.26,2.553-5.363-3.762-.261-5.979,1.88-3.134,4.772-2.049,5.875",
    transform: "translate(-419.465 -423.128)",
    fill: "#fefefe"
  }))))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24092",
    "data-name": "Path 24092",
    d: "M257.922,292.856a15.023,15.023,0,0,1-3.518-5.718l0-.01c-.1-.3-.2-.622-.282-.916l-1.213-3.942c-2.272-6.239-.016-14.081,5.618-19.524s13.591-7.474,19.824-5.074l3.937,1.3q.48.142.95.314a15.2,15.2,0,0,1,5.679,3.631,16.17,16.17,0,0,1,4.3,13.462,23.707,23.707,0,0,1-7.29,14.217,24.087,24.087,0,0,1-14.528,6.86q-.876.075-1.73.074a16.145,16.145,0,0,1-11.739-4.673m19.789-33.462c-5.573-2.166-12.764-.291-17.894,4.665s-7.2,12.031-5.162,17.608c.006.015.01.03.015.045L255.9,285.7c.078.285.165.566.255.831l0,.009v0a13.2,13.2,0,0,0,3.09,5.027,14.675,14.675,0,0,0,11.986,4.052,22.23,22.23,0,0,0,13.395-6.346,21.876,21.876,0,0,0,6.743-13.108,14.38,14.38,0,0,0-3.782-11.977,13.34,13.34,0,0,0-4.968-3.182l-.034-.012c-.268-.1-.548-.19-.859-.283l-3.935-1.3c-.028-.008-.055-.017-.082-.027",
    transform: "translate(-235.271 -239.76)",
    fill: "#371a45"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24093",
    "data-name": "Path 24093",
    d: "M255.776,286.9h0A14.215,14.215,0,0,1,252,275.063a20.787,20.787,0,0,1,6.392-12.468,21.121,21.121,0,0,1,12.741-6.014,14.506,14.506,0,0,1,11.841,4.045,14.215,14.215,0,0,1,3.779,11.833,20.788,20.788,0,0,1-6.392,12.468,21.122,21.122,0,0,1-12.741,6.015q-.769.066-1.52.066a14.2,14.2,0,0,1-10.321-4.11m15.513-28.488a19.262,19.262,0,0,0-11.607,5.5,18.958,18.958,0,0,0-5.844,11.359,12.424,12.424,0,0,0,3.264,10.348,12.667,12.667,0,0,0,10.356,3.5,19.262,19.262,0,0,0,11.607-5.5,18.959,18.959,0,0,0,5.844-11.359,11.941,11.941,0,0,0-12.267-13.905q-.668,0-1.354.059",
    transform: "translate(-235.135 -239.609)",
    fill: "#371a45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24094",
    "data-name": "Path 24094",
    d: "M82.224,124.485a22.1,22.1,0,0,0,5.213-.588,1.023,1.023,0,0,0,.754-1.239,1.034,1.034,0,0,0-1.251-.747,23.075,23.075,0,0,1-8.794.182c-20.387-3.6-46.634-25.724-62.432-52.616C2.7,47.324-1.174,25.911,4.8,9.184a7.906,7.906,0,0,1,5-4.826C26.823-1.136,48.325,3.25,70.34,16.706c26.725,16.336,48.377,42.9,51.482,63.167a22.592,22.592,0,0,1-.4,8.731,1.022,1.022,0,0,0,.722,1.258,1.033,1.033,0,0,0,1.27-.715,24.27,24.27,0,0,0,.451-9.6c-1.566-10.219-7.751-22.362-17.411-34.167A142.193,142.193,0,0,0,71.424,14.965C48.884,1.187,26.771-3.271,9.158,2.411a9.976,9.976,0,0,0-6.3,6.09C-3.327,25.8.607,47.825,13.93,70.506a141.594,141.594,0,0,0,29.785,35.473c11.663,9.871,23.754,16.308,34.046,18.124a24.82,24.82,0,0,0,4.463.382",
    transform: "translate(0 -0.005)",
    fill: "#371a45"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24095",
    "data-name": "Path 24095",
    d: "M1245.694,1314.418h0l-7.959-15.271a13.256,13.256,0,0,1-.287-11.643,41.833,41.833,0,0,1,22.237-21.49,13.4,13.4,0,0,1,11.689.6l15.225,8.286a8.3,8.3,0,0,1,4.362,7.948c-1.092,13.081-24.137,35.344-37.361,36.093-.156.009-.312.013-.468.013a8.417,8.417,0,0,1-7.439-4.537m14.8-46.522a39.834,39.834,0,0,0-21.173,20.464,11.213,11.213,0,0,0,.246,9.847l7.959,15.271-.918.47.918-.47a6.338,6.338,0,0,0,5.953,3.42c12.231-.693,34.411-22.12,35.421-34.219a6.259,6.259,0,0,0-3.3-5.985l-15.226-8.286a11.529,11.529,0,0,0-5.5-1.392,11.244,11.244,0,0,0-4.383.879",
    transform: "translate(-1154.024 -1181.584)",
    fill: "#371a45"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7679",
    "data-name": "Group 7679",
    transform: "translate(100.12 101.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7678",
    "data-name": "Group 7678",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24113",
    "data-name": "Path 24113",
    d: "M0,0,90.126.408l.408,90.128L.408,90.128Z",
    transform: "matrix(0.705, -0.709, 0.709, 0.705, -32.425, 32.067)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7690",
    "data-name": "Group 7690",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7689",
    "data-name": "Group 7689",
    clipPath: "url(#clip-path)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24097",
    "data-name": "Path 24097",
    d: "M1378.992,1454.741a.927.927,0,0,0,.646-.26.912.912,0,0,0,.017-1.3c-1.741-1.77-2.122-4.436-1.13-7.924,3.244-11.413,20.16-27.754,31.755-30.677,3.543-.893,6.223-.448,7.964,1.322a.932.932,0,0,0,1.309.017.911.911,0,0,0,.017-1.3c-2.2-2.242-5.575-2.871-9.746-1.82-5.738,1.446-13.155,6.165-19.84,12.624s-11.635,13.686-13.24,19.334c-1.167,4.105-.618,7.46,1.587,9.7a.927.927,0,0,0,.663.277",
    transform: "translate(-1284.624 -1319.23)",
    fill: "#371a45"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24098",
    "data-name": "Path 24098",
    d: "M1139,1210.175a.926.926,0,0,0,.771-.408.912.912,0,0,0-.256-1.272.941.941,0,0,0-.179-.093,8.019,8.019,0,0,1-2.864-1.85c-2.69-2.734-3.169-7.35-1.349-13,1.884-5.844,5.984-12.021,11.544-17.394s11.9-9.276,17.84-10.993c5.742-1.659,10.386-1.067,13.076,1.667a7.812,7.812,0,0,1,1.566,2.318.928.928,0,0,0,1.44.335.911.911,0,0,0,.241-1.1,9.631,9.631,0,0,0-1.921-2.829c-3.19-3.243-8.489-4.006-14.919-2.148-6.229,1.8-12.84,5.862-18.614,11.441s-10.042,12.024-12.016,18.149c-2.038,6.323-1.4,11.592,1.787,14.835a9.857,9.857,0,0,0,3.5,2.273.93.93,0,0,0,.353.069",
    transform: "translate(-1056.891 -1085.803)",
    fill: "#371a45"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24099",
    "data-name": "Path 24099",
    d: "M1598.577,1633.7l.125.094c-19.345-23.237-5.826-48.747-32.433-46.707-5.764,2.909-10.068,7.831-13.981,13.292-2.736,26.308,23.343,13.564,46.289,33.322",
    transform: "translate(-1448.867 -1482.377)",
    fill: "#ffcf02"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24100",
    "data-name": "Path 24100",
    d: "M902.332,928.29c12.9,13.112,18.427,13.481,21.694,10.325s3.037-8.642-9.862-21.755-26-21.183-29.271-18.027,4.54,16.345,17.439,29.457",
    transform: "translate(-825.349 -838.956)",
    fill: "#eb201a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7682",
    "data-name": "Group 7682",
    transform: "translate(58.801 60.448)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7681",
    "data-name": "Group 7681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7680",
    "data-name": "Group 7680",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24101",
    "data-name": "Path 24101",
    d: "M902.338,946.075c12.9,13.112,18.426,13.48,21.693,10.324,1.491-1.44,2.255-3.367,1.414-6.284a5.64,5.64,0,0,1-1.494,2.3c-3.267,3.156-8.8,2.789-21.7-10.324-9.412-9.568-16.112-19.176-17.777-24.9-2.025,3.953,5.628,16.453,17.859,28.887",
    transform: "translate(-884.155 -917.188)",
    fill: "#000072"
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7685",
    "data-name": "Group 7685",
    transform: "translate(58.801 59.193)",
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7684",
    "data-name": "Group 7684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7683",
    "data-name": "Group 7683",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24102",
    "data-name": "Path 24102",
    d: "M884.865,904.351a2.907,2.907,0,0,1,.742-2.239c3.267-3.156,16.373,4.915,29.271,18.028,6.315,6.419,9.594,11.011,10.911,14.4-.031-3.531-2.987-8.891-11.624-17.671-12.9-13.113-26-21.184-29.271-18.027-1.011.977-.962,2.914-.029,5.512",
    transform: "translate(-884.151 -898.155)",
    fill: "#fefefe"
  }))))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24103",
    "data-name": "Path 24103",
    d: "M888.8,916.207a103.536,103.536,0,0,1-14.917-18.638c-2.5-4.219-4.959-9.745-2.505-12.116,4.272-4.127,18.945,6.216,30.58,18.044,11.359,11.547,14.4,18.657,9.845,23.052a6.341,6.341,0,0,1-4.561,1.892c-4.389,0-10.328-3.984-18.442-12.233m-16.13-29.441c-.933.9-.686,3.97,2.81,9.874a101.664,101.664,0,0,0,14.646,18.286c13.563,13.788,18.13,12.486,20.385,10.308s3.685-6.67-9.878-20.458c-12.2-12.4-22.621-18.433-26.6-18.433a1.906,1.906,0,0,0-1.36.422",
    transform: "translate(-812.482 -826.233)",
    fill: "#371a45"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24104",
    "data-name": "Path 24104",
    d: "M1550.913,1593.354c-10.1-6.083-19.592-7.031-27.227-7.786a34.594,34.594,0,0,1-22.336-8.142,34.082,34.082,0,0,1-11.317-21.24,13.023,13.023,0,0,1,1.268-7.849c3.678-7.249,11.941-15.257,19.221-18.628a13.42,13.42,0,0,1,7.927-1.047,34.576,34.576,0,0,1,21.182,11.742,33.892,33.892,0,0,1,7.661,22.357c.567,7.583,1.282,17.014,7.161,27.171a2.484,2.484,0,0,1-.43,3.074,2.542,2.542,0,0,1-1.773.726,2.589,2.589,0,0,1-1.339-.378m-39.516-61.79c-6.8,3.147-14.813,10.919-18.25,17.693a11,11,0,0,0-1.07,6.631c2.456,16.526,14.893,27.373,31.685,27.633.029,0,.058,0,.086.005,7.851.776,17.621,1.742,28.138,8.078a.462.462,0,0,0,.6-.064.452.452,0,0,0,.08-.591c-6.123-10.58-6.849-20.283-7.432-28.081,0-.029,0-.057,0-.085.166-16.668-10.482-29.27-27.127-32.1a11.579,11.579,0,0,0-1.942-.165,11.309,11.309,0,0,0-4.761,1.049m-20.346,24.474h0Z",
    transform: "translate(-1390.803 -1427.732)",
    fill: "#371a45"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24105",
    "data-name": "Path 24105",
    d: "M1716.553,1512.529a.928.928,0,0,0,.533-.168c7.183-5.024,11.153-6.15,12.475-5.531.159.075.583.274.653,1.265a.926.926,0,0,0,1.847-.129,3.067,3.067,0,0,0-1.707-2.793c-2.461-1.156-7.285.757-14.336,5.689a.912.912,0,0,0-.223,1.279.927.927,0,0,0,.757.388",
    transform: "translate(-1601.528 -1405.667)",
    fill: "#371a45"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24106",
    "data-name": "Path 24106",
    d: "M1468.565,1762.652a.917.917,0,0,0,.088-1.83c-1-.1-1.187-.519-1.259-.679-.593-1.325.645-5.23,5.9-12.218a.912.912,0,0,0-.19-1.284.931.931,0,0,0-1.3.188c-5.155,6.86-7.209,11.589-6.1,14.058a3.094,3.094,0,0,0,2.774,1.762c.03,0,.06,0,.09,0",
    transform: "translate(-1367.953 -1631.357)",
    fill: "#371a45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24107",
    "data-name": "Path 24107",
    d: "M13.87,52.124a.923.923,0,0,0,.914-.782A38.551,38.551,0,0,1,26.419,29.747,39.138,39.138,0,0,1,48.5,18.772a.929.929,0,0,0,.6-.323.912.912,0,0,0-.118-1.292.926.926,0,0,0-.742-.2A41.008,41.008,0,0,0,25.127,28.434,40.386,40.386,0,0,0,12.953,51.07a.919.919,0,0,0,.778,1.043.965.965,0,0,0,.138.01",
    transform: "translate(-12.082 -15.827)",
    fill: "#371a45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24108",
    "data-name": "Path 24108",
    d: "M1528.035,626.315c5.962,0,11.638-.11,12.72-.506a6.411,6.411,0,0,0,3.744-5.186c.531-3.692-1.2-9.824-12.452-18.073-17.291-12.676-40.48-16.35-40.712-16.385a1.024,1.024,0,1,0-.316,2.023c.227.035,22.927,3.638,39.8,16.008,10.984,8.053,12.005,13.568,11.636,16.138a4.444,4.444,0,0,1-2.416,3.554c-1.361.457-14.678.456-26.515.224a1.023,1.023,0,1,0-.041,2.046c2.105.041,8.477.155,14.552.155",
    transform: "translate(-1391.042 -547.522)",
    fill: "#371a45"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24109",
    "data-name": "Path 24109",
    d: "M1814.042,1033.791a.922.922,0,0,0,.7-.315,4.669,4.669,0,0,0,1.023-3.559,5.772,5.772,0,0,0-3.142-3.88c-4.9-2.881-27.449-3.062-28.406-3.068h-.006a.917.917,0,1,0-.006,1.834c6.383.042,23.762.63,27.474,2.812a4.1,4.1,0,0,1,2.256,2.579,2.836,2.836,0,0,1-.6,2.086.915.915,0,0,0,.106,1.29.929.929,0,0,0,.6.221",
    transform: "translate(-1664.683 -955.548)",
    fill: "#371a45"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24110",
    "data-name": "Path 24110",
    d: "M586.912,1553.019a8.576,8.576,0,0,0,.98-.056,6.46,6.46,0,0,0,5.326-3.577c.862-2.143,1.025-22.874,1.049-27.009a1.028,1.028,0,0,0-1.027-1.029h-.006a1.028,1.028,0,0,0-1.033,1.018c-.068,11.733-.407,24.925-.9,26.264a4.482,4.482,0,0,1-3.646,2.3c-2.6.3-8.14-.851-15.984-11.938-12.048-17.031-15.1-39.61-15.134-39.837a1.033,1.033,0,0,0-2.048.262c.03.231,3.145,23.3,15.491,40.75,7.368,10.415,13.144,12.852,16.934,12.852",
    transform: "translate(-517.602 -1399.518)",
    fill: "#371a45"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24111",
    "data-name": "Path 24111",
    d: "M990.284,1834.807a4.906,4.906,0,0,0,2.861-.992.912.912,0,0,0,.127-1.291.931.931,0,0,0-1.3-.13,2.892,2.892,0,0,1-2.119.537,4.119,4.119,0,0,1-2.545-2.3c-2.107-3.734-2.256-20.965-2.136-27.289a.921.921,0,0,0-.908-.934h-.018a.921.921,0,0,0-.925.9c-.018.949-.41,23.291,2.371,28.219a5.8,5.8,0,0,0,3.834,3.211,4.11,4.11,0,0,0,.756.07",
    transform: "translate(-917.9 -1683.617)",
    fill: "#371a45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7688",
    "data-name": "Group 7688",
    transform: "translate(101.24 50.286)",
    opacity: 0.2,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7687",
    "data-name": "Group 7687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7686",
    "data-name": "Group 7686",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24112",
    "data-name": "Path 24112",
    d: "M1522.283,763.033l.02-.027c-.009-.006-.015,0-.02.027",
    transform: "translate(-1522.283 -763.003)",
    fill: "#000072"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e4d84ef52e5d00d41e2c21962c8b5a3f.svg";
export { ForwardRef as ReactComponent };